export default __webpack_public_path__ + "static/media/ic_buy_glp.b4c18be7.svg";